// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"19784":"da2092c9a73e5f36","88135":"fe5cb783e6b16edf","91179":"bbef501aba8f3c4a"}[chunkId] + ".css";
};